import { Spine } from '@esotericsoftware/spine-pixi-v8';
import { Texture } from 'pixi.js';
import { GameConstants } from '../gameClientEvents/GameConstants';
// import { Texture } from "pixi.js";


// Define the mapping configuration
const symbolConfig: Record<number, { blurSymName?: string; staticSymName?: string; skeleton: string; atlas: string }> = {
    0: {
        blurSymName: "wildBlur",
        staticSymName: "wildStatic",
        skeleton: "wildSkel",
        atlas: "wildAtlas"
    },
    1: {
        blurSymName: "lv5Blur",
        staticSymName: "lv5Static",
        skeleton: "lv5Skel",
        atlas: "lv5Atlas"
    },
    2: {
        blurSymName: "lv4Blur",
        staticSymName: "lv4Static",
        skeleton: "lv4Skel",
        atlas: "lv4Atlas"
    },
    3: {
        blurSymName: "lv3Blur",
        staticSymName: "lv3Static",
        skeleton: "lv3Skel",
        atlas: "lv3Atlas"
    },
    4: {
        blurSymName: "lv2Blur",
        staticSymName: "lv2Static",
        skeleton: "lv2Skel",
        atlas: "lv2Atlas"
    },
    5: {
        blurSymName: "lv1Blur",
        staticSymName: "lv1Static",
        skeleton: "lv1Skel",
        atlas: "lv1Atlas"
    },
    6: {
        blurSymName: "hv5Blur",
        staticSymName: "hv5Static",
        skeleton: "hv5Skel",
        atlas: "hv5Atlas"
    },
    7: {
        blurSymName: "hv4Blur",
        staticSymName: "hv4Static",
        skeleton: "hv4Skel",
        atlas: "hv4Atlas"
    },
    8: {
        blurSymName: "hv3Blur",
        staticSymName: "hv3Static",
        skeleton: "hv3Skel",
        atlas: "hv3Atlas"
    },
    9: {
        blurSymName: "hv2Blur",
        staticSymName: "hv2Static",
        skeleton: "hv2Skel",
        atlas: "hv2Atlas"
    },
    10: {
        blurSymName: "hv1Blur",
        staticSymName: "hv1Static",
        skeleton: "hv1Skel",
        atlas: "hv1Atlas"
    },
    12: {
        blurSymName: "scatterBlur",
        staticSymName: "scatterStatic",
        skeleton: "scatterSkel",
        atlas: "scatterAtlas"
    },
    13: {
        blurSymName: "specialSymbolBlur",
        staticSymName: "specialSymbolStatic",
        skeleton: "specialSymbolSkel",
        atlas: "specialSymbolAtlas"
    },
    // Gold coin
    100: {
        skeleton: "goldCoinSkel",
        atlas: "goldCoinAtlas"
    },
    // Add more mappings as needed
    // Note: The symbol indeces from 111 to 117 are the custom symbols based on feature type
    // WE are not getting these id's from server
    111: {
        skeleton: "doubleSkel",
        atlas: "doubleAtlas"
    },
    112: {
        skeleton: "multiSkel",
        atlas: "multiAtlas"
    },
    113: {
        skeleton: "extraSkel",
        atlas: "extraAtlas"
    },
    114: {
        skeleton: "doubleMultiSkel",
        atlas: "doubleMultiAtlas"
    },
    115: {
        skeleton: "doubleExtraSkel",
        atlas: "doubleExtraAtlas"
    },
    116: {
        skeleton: "multiExtraSkel",
        atlas: "multiExtraAtlas"
    },
    117: {
        skeleton: "doubleMultiExtraSkel",
        atlas: "doubleMultiExtraAtlas"
    },
};

export const SymbolValues = [{ id: 14, value: 1 }, { id: 15, value: 2 }, { id: 16, value: 3 }, { id: 17, value: 4 }, { id: 18, value: 5 }, { id: 19, value: 6 }, { id: 20, value: 7 }, { id: 21, value: 8 }, { id: 22, value: 9 }, { id: 23, value: 10 }, { id: 24, value: 20 }, { id: 25, value: 50 }, {id : 26, value: 100}];
export const SymbolValMap = SymbolValues.reduce<Record<number, any>>((acc, curr) => {
    acc[curr.id] = curr.value;
    return acc;
}, {});

export function isOversizeSymbol(symbolIndex: number): boolean {
    let isSymbolOversize = false;
    if (symbolIndex == 0)// || symbolIndex == 9)
    {
        isSymbolOversize = false;
    }
    return isSymbolOversize;

}

export function isLandingAnimationExist(symbolIndex: number): boolean {
    let isLandingExist = true;
    if (symbolIndex == 0 || symbolIndex == 9) {
        isLandingExist = true;
    }
    return isLandingExist;
}

export function isIdleExist(symbolIndex: number): boolean {
    let isIdleExist = false;
    if (
        symbolIndex === GameConstants.RIP_SYMBOL_ID ||
        symbolIndex === GameConstants.RIP_SYMBOL_MAP.REPLICATE_SYMBOL_ID ||
        symbolIndex === GameConstants.RIP_SYMBOL_MAP.REINFEST_SYMBOL_ID ||
        symbolIndex === GameConstants.RIP_SYMBOL_MAP.REAWAKEN_SYMBOL_ID ||
        symbolIndex === GameConstants.RIP_SYMBOL_MAP.REPLICATE_REINFEST_SYMBOL_ID ||
        symbolIndex === GameConstants.RIP_SYMBOL_MAP.REPLICATE_REAWAKEN_SYMBOL_ID ||
        symbolIndex === GameConstants.RIP_SYMBOL_MAP.REINFEST_REAWAKEN_SYMBOL_ID ||
        symbolIndex === GameConstants.RIP_SYMBOL_MAP.REPLICATE_REINFEST_REAWAKEN_SYMBOL_ID
    ) {
        isIdleExist = true;
    }
    return isIdleExist;
}


export function getSymbol(symbolIndex: number, isFullRes?: boolean): Texture {

    let staticSymName: string = '';

    const symbol = symbolConfig[symbolIndex];

    if (symbol) {
        if (isFullRes && isFullRes == true) {
            staticSymName = symbol.staticSymName;
        }
        else {
            staticSymName = symbol.blurSymName;
        }
    }

    const staticSymbol: Texture = Texture.from(staticSymName);
    return staticSymbol;

}


export function getSpineSymbol(symbolIndex: number): Spine {
    const symbol = symbolConfig[symbolIndex];

    let skeletonVal: string = '';
    let atlasVal: string = '';

    if (symbol) {

        skeletonVal = symbol.skeleton;
        atlasVal = symbol.atlas;

        // console.log(skeletonVal);
        // console.log(atlasVal);

        // console.log(spineSymbol);

    }


    const spineSymbol: Spine = Spine.from({
        skeleton: skeletonVal,
        atlas: atlasVal,
        // skeleton: "lemonSkeleton",
        // atlas: "lemonAtlas",
    });

    // spineSymbol.update(1);

    // spineSymbol.state.setAnimation(0, "win", true);

    return spineSymbol;


}






